export default __webpack_public_path__ + "static/media/covid.ab0f115d.png";